import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';

import {
	INITIAL_REQUEST_SUCCESS,
	RELEASE_VERSION_FAILURE,
	RELEASE_VERSION_SUCCESS,
} from '../state/actions';
import {
	getOnOpenedHandler,
	getOnSuccessHandler,
	getOnErrorHandler,
	getVersionId,
	shouldRedirectToCreateReleaseNotes,
} from '../state/selectors';
import type { State } from '../state/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initialRequestSuccessEpic: Epic<any, State> = (action$, store) =>
	action$.ofType(INITIAL_REQUEST_SUCCESS).mergeMap(() => {
		const state = store.getState();
		const versionId = getVersionId(state);
		getOnOpenedHandler(state)({ id: versionId });
		return Observable.empty<never>();
	});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const releaseVersionRequestSuccessEpic: Epic<any, State> = (action$, store) =>
	action$.ofType(RELEASE_VERSION_SUCCESS).mergeMap(({ payload: version }) => {
		const state = store.getState();
		getOnSuccessHandler(state)(version, {
			shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes(state),
		});
		return Observable.empty<never>();
	});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const releaseVersionRequestFailureEpic: Epic<any, State> = (action$, store) =>
	action$.ofType(RELEASE_VERSION_FAILURE).mergeMap(({ payload: id }) => {
		const state = store.getState();
		getOnErrorHandler(state)(id);
		return Observable.empty<never>();
	});
